import { render } from "./teaAgeEcharts.vue?vue&type=template&id=c72cecee&scoped=true"
import script from "./teaAgeEcharts.vue?vue&type=script&lang=js"
export * from "./teaAgeEcharts.vue?vue&type=script&lang=js"

import "./teaAgeEcharts.vue?vue&type=style&index=0&id=c72cecee&scoped=true&lang=scss"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c72cecee"]])

export default __exports__